import clsx from 'clsx';
import React from 'react';

import type { PageContentBlock, PostContentBlock } from '@/blocks';

import { CookieList } from './CookieList';
import FaqsWithCategory from './FaqsWithCategory';
import { HtmlBlock } from './HtmlBlock';
import { ImageBlock } from './Image';
import { InstagramBlock } from './InstagramBlock';
import { RichTextBlock } from './RichText';
import { TwitterBlock } from './TwitterBlock';
import { VideoBlock } from './Video';

interface Props {
  blocks: PageContentBlock[] | PostContentBlock[];
  className?: string;
}

export const RenderBlocks: React.FC<Props> = ({ blocks, className }) => {
  return (
    <div className={clsx(className)}>
      {blocks.map((block, i) => {
        switch (block.__typename) {
          case 'RichText':
            return <RichTextBlock block={block} key={block.id} />;

          case 'FaqsWithCategory':
            return <FaqsWithCategory block={block} key={block.id} />;

          case 'ImageBlock':
            return <ImageBlock block={block} key={block.id} />;

          case 'VideoBlock':
            return <VideoBlock block={block} key={block.id} />;

          case 'Html':
            return <HtmlBlock block={block} key={block.id} />;

          case 'CookieList':
            return <CookieList key={block.id} />;

          case 'InstagramBlock':
            return <InstagramBlock block={block} key={block.id} />;

          case 'TwitterBlock':
            return <TwitterBlock block={block} key={block.id} />;

          default:
            return (
              <p className="text-red-500" key={i}>
                {JSON.stringify(block, null, 2)}
              </p>
            );
        }
      })}
    </div>
  );
};
